export default {
  contained: {
    padding: '8px !important',
    minWidth: 'unset',
  },
}
